<template>
    <div class="animated fadeIn">
        <div>
            <b-row>
                <b-col>
                    <h4>Contact Us Enquiries</h4>
                </b-col>
                <b-col cols="12" md="2"
                 class="mb-2 mb-md-0">
                    <eb-select
                        v-if="hideSelect"
                        type="select"
                        class="w-100"
                        v-model="selectedDurationOption"
                        :options="durationOptions"
                        label="text"
                        :id="'selectduration'"
                        :placeholder="'Time Duration'"
                        :selected="selectedDurationOption.text"
                        @input="changeDuration"
                    ></eb-select>
                    <c-date
                        ref="compRefs"
                        modalRef="modalRef"
                        modalId="dateModal"
                         class="w-100 mt-2"
                        @customDateRange="findDateResult"
                    ></c-date>
                </b-col>
                <b-col cols="12" md="2"
                 class="mb-2 mb-md-0">
                    <eb-select
                        id="selectSearch"
                        v-model="selectSearch"
                        :options="searchOptions"
                        label="text"
                        placeholder="Select Search"
                        :selected="selectSearch"
                        class="w-100"
                        @input="searchQuery = ''"
                    ></eb-select>
                </b-col>
                    <!--                    <ValidationProvider-->
                    <!--                        :rules="getValidationRules(selectSearch?.value)"-->
                    <!--                        v-slot="{ errors }"-->
                    <!--                        name="Search"-->
                    <!--                    >-->
                    <!--                        <CustInput-->
                    <!--                            inputType="text"-->
                    <!--                            inputId="search"-->
                    <!--                            :labelText="-->
                    <!--                                selectSearch-->
                    <!--                                    ? 'Search ' + selectSearch.text-->
                    <!--                                    : 'Search...'-->
                    <!--                            "-->
                    <!--                            v-model="searchValue"-->
                    <!--                            @keyup.enter.native="onSearchInput"-->
                    <!--                            class="w-100"-->
                    <!--                        />-->
                    <!--                        <span v-if="searchValue" class="validate-error">{{-->
                    <!--                            errors[0]-->
                    <!--                        }}</span>-->
                    <!--                    </ValidationProvider>-->
                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                    <div class="search-input-wrapper w-100">
  <input
    type="text"
    class="search-input"
    placeholder="Search here"
    v-model="searchValue"
    @keyup.enter="onSearchInput"
  />

 
  <i
    v-if="!searchValue"
    class="fa fa-search search-icon"
    aria-hidden="true"
    @click="onSearchInput"
  ></i>

 
  <i
    v-else
    class="fa fa-times search-icon clear-icon"
    aria-hidden="true"
    @click="clearSearch"
  ></i>
</div>

                

                </b-col>
                <!-- <b-col md="4">
                    <CustInput
                        inputType="text"
                        inputId="search"
                        :labelText="
                            selectSearch
                                ? 'Search ' + selectSearch.text
                                : 'Search...'
                        "
                        v-model="searchValue"
                        @keyup.enter.native="onSearchInput"
                        class="w-100"
                    />
                    <button class="text-grey searchIcon" @click="onSearchInput">
                        <i class="fa fa-search mt-2" aria-hidden="true"></i>
                    </button>
                </b-col> -->
                <!-- <b-col md="2">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Select Search"
                    >
                    <label for="assetCategory">Asset Category *</label>
                    <eb-select
                        id="selectTenant"
                        v-model="selectTenant"
                        :options="tenantOptions"
                        label="text"
                        placeholder="Select Tenant"
                        class="w-100"
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col> -->
            </b-row>
        </div>
        <b-card>
            <b-row>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Total"
                        :value="contactEnquiryList.totalCount"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Open"
                        :value="getStatusCount('OPEN')"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Closed"
                        :value="getStatusCount('CLOSED')"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Clarification"
                        :value="getStatusCount('CLARIFICATION')"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Reopen"
                        :value="getStatusCount('REOPEN')"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Resolved"
                        :value="getStatusCount('RESOLVED')"
                        bottomColor="#42b039"
                    ></dashboardInfoCard>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <div>
                        <div class="table-wrapper">
                            <b-table
                                class="contact-enquiry-table tableRadius"
                                id="contactUs"
                                :dark="false"
                                :hover="true"
                                :striped="true"
                                :bordered="true"
                                :small="false"
                                :fixed="false"
                                responsive
                                :items="filteredList"
                                :fields="contactUsColumns"
                                :current-page="currentPage"
                                :per-page="perPage"
                                filter
                                thead-class="header"
                                show-empty
                                :busy="loading"
                            >
                                <template slot="cell(action)" slot-scope="data">
                                    <div class="inline_btnTable">
                                        <b-button
                                            size="sm"
                                            class="button-circle mr-2"
                                            variant="primary"
                                            @click="
                                                viewContactUsDetails(data.item)
                                            "
                                        >
                                            <i class="fa fa-eye"></i>
                                        </b-button>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="pagination-wrapper">
                            <b-pagination
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="contactEnquiryList.totalCount"
                                aria-controls="partner-table"
                                prev-text="Prev"
                                next-text="Next"
                                hide-goto-end-buttons
                                @change="getContactUsData"
                            ></b-pagination>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
            id="modalView"
            v-model="showModalView"
            centered
            title="Enquiry Details"
            header-class="mb-3 header-text "
            footer-class="border-0 footer-button"
            modal-class="p-3"
            hide-footer
            ref="field-modal"
        >
            <div>
                <label for="name">
                    Name: <span> {{ contactDetails.name }}</span></label
                >
            </div>
            <div>
                <label for="businessName">
                    Business Name:
                    <span> {{ contactDetails.businessName }}</span></label
                >
            </div>
            <div>
                <label for="email">
                    Email: <span> {{ contactDetails.email }}</span></label
                >
            </div>
            <div>
                <label for="phone">
                    Phone Number:
                    <span> {{ contactDetails.phone }}</span></label
                >
            </div>
            <div>
                <label for="message">
                    Message : <span> {{ contactDetails.message }}</span></label
                >
            </div>
            <div>
                <label for="status" class="d-inline-block mr-2">Status:</label>
                <eb-select
                    id="statusSelect"
                    v-model="contactDetails.status"
                    :options="enquiryStatusOptions"
                    label="text"
                    :selected="contactDetails.status"
                    placeholder="Select Status"
                    class="w-100 responsive-select"
                    @input="updateStatus"
                ></eb-select>
            </div>
           <b-row class="mt-4 mb-1 justify-content-center text-center">
    <b-col cols="12" sm="6" md="3" class="mb-2">
        <b-button
            variant="danger"
            class="w-100"
            @click="showModalView = false"
        >
            CANCEL
        </b-button>
    </b-col>

    <b-col cols="12" sm="6" md="3" class="mb-2">
        <b-button
            variant="primary"
            class="w-100"
            @click="updateEnquiryStatus"
        >
            SAVE
        </b-button>
    </b-col>
</b-row>

        </b-modal>
    </div>
</template>

<script>
import CustInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select";
import dashboardInfoCard from "@/components/Generics/dashboardInfoCard.vue";
import cDate from "@/components/FormElements/CustomDate.vue";
import moment from "moment";
import { mapState } from "vuex";
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        dashboardInfoCard,
        CustInput,
        ebSelect,
        cDate,
    },
    data() {
        return {
            loading: false,
            startDate: "",
            endDate: "",
            hideSelect: true,
            selectSearch: { text: "Name", value: "name" },
            searchValue: "",
            searchOptions: [
                { text: "Name", value: "name" },
                { text: "Email", value: "email" },
                { text: "Status", value: "status" },
            ],
            selectTenant: { text: "All Tenants", value: "all" },
            tenantOptions: [
                { text: "All Tenants", value: "all" },
                { text: "Tenant A", value: "a" },
                { text: "Tenant B", value: "b" },
            ],
            contactUsColumns: [
                {
                    label: "Name",
                    key: "name",
                    thStyle: { minWidth: "120px" },
                },
                {
                    label: "Business Name",
                    key: "businessName",
                    thStyle: { minWidth: "120px" },
                },
                {
                    label: "Email",
                    key: "email",
                    thStyle: { minWidth: "160px" },
                },
                {
                    label: "Message",
                    key: "message",
                    thStyle: { minWidth: "200px" },
                    tdClass: "message-cell",
                },
                {
                    label: "Status",
                    key: "status",
                    thStyle: { minWidth: "100px" },
                },
                {
                    key: "action",
                    thStyle: { width: "80px" },
                },
            ],
            currentPage: 1,
            perPage: 10,
            showModalView: false,
            contactDetails: "",
            enquiryStatusOptions: [
                { text: "OPEN", value: "OPEN" },
                { text: "CLOSED", value: "CLOSED" },
                { text: "CLARIFICATION", value: "CLARIFICATION" },
                { text: "REOPEN", value: "REOPEN" },
                { text: "RESOLVED", value: "RESOLVED" },
            ],
            timeRange: "",
            selectedDurationOption: {
                text: "Today",
                value: 1,
            },
            durationOptions: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 Days",
                    value: 7,
                },
                {
                    text: "30 days",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            fromDate: moment().format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD"),
            newStatus: "",
        };
    },
    computed: {
        ...mapState({
            contactEnquiryList: (state) =>
                state.contactUsEnquiry.contactEnquiryList,
        }),
        filteredList() {
            if (
                !this.contactEnquiryList ||
                !this.contactEnquiryList.serviceRequests
            ) {
                return [];
            }
            const mappedList = this.contactEnquiryList.serviceRequests.map(
                (request) => {
                    const {
                        reportedBy = {},
                        companyName = "",
                        description = "",
                        status = "",
                        _id = "",
                    } = request;
                    const { name = "", email = "", phone = "" } = reportedBy;
                    return {
                        name,
                        businessName: companyName,
                        email,
                        phone,
                        message: description,
                        status,
                        _id,
                    };
                },
            );

            if (!this.searchValue?.trim()) {
                return mappedList;
            }

            const searchLower = this.searchValue.trim().toLowerCase();
            const searchField = this.selectSearch?.value;

            return mappedList.filter((item) => {
                const value =
                    searchField === "name"
                        ? item.name
                        : searchField === "email"
                          ? item.email
                          : searchField === "status"
                            ? item.status
                            : "";
                return String(value || "").toLowerCase().includes(searchLower);
            });
        },
    },
    methods: {
        clearSearch() {
            this.searchValue = "";
            this.onSearchInput(); 
        },
    
        getValidationRules(field) {
            switch (field) {
                case "name":
                    return "required|alpha";
                case "email":
                    return "required|email";
                case "phoneNumber":
                    return "required|numeric|digits:10";
                default:
                    return "";
            }
        },
        getStatusCount(status) {
            if (
                !this.contactEnquiryList ||
                !this.contactEnquiryList.serviceRequests
            ) {
                return 0;
            }
            return this.contactEnquiryList.serviceRequests.filter(
                (request) => request.status === status,
            ).length;
        },
        updateStatus(val) {
            this.newStatus = val.value;
        },
        async changeDuration() {
            let e = this.selectedDurationOption;
            if (e.value == "custom") {
                this.hideSelect = false;
                this.$refs["compRefs"].openModal();
                setTimeout(() => {
                    this.hideSelect = true;
                }, 30);
                return;
            } else {
                this.fromDate = moment()
                    .subtract(e.value - 1, "days")
                    .format("YYYY-MM-DD");
                this.toDate = moment().format("YYYY-MM-DD");
                this.startDate = null;
                this.endDate = null;
            }
            await this.onSearchInput();
        },
        async findDateResult(e) {
            this.fromDate = e.fromDate;
            this.toDate = e.toDate;
            this.timeRange = "";
            await this.onSearchInput();
        },
        async getContactUsData(e) {
            this.currentPage = e;
            // await this.getPortfolioListData(this.search);
        },
        async onSearchInput() {
            let payload = {
                fromDate: this.fromDate,
                toDate: this.toDate,
            };

            if (this.searchValue) {
                switch (this.selectSearch?.value) {
                    case "name":
                        payload = { ...payload, name: this.searchValue };
                        break;
                    case "email":
                        payload = { ...payload, email: this.searchValue };
                        break;
                    case "status":
                        payload = { ...payload, status: this.searchValue };
                        break;
                }
            }

            await this.$store.dispatch(
                "contactUsEnquiry/fetchContactEnquiryList",
                payload,
            );
        },
        async viewContactUsDetails(item) {
            this.contactDetails = item;
            this.showModalView = true;
        },
        async updateEnquiryStatus() {
            const { _id } = this.contactDetails;
            const { userName, email, phone } = this.$currentUserData;
            const payload = {
                id: _id,
                body: {
                    status: this.newStatus,
                    category: "67e1c19531d4efe0a060b6bd",
                    description: "update status",
                    updatedBy: {
                        name: userName,
                        email: email,
                        phone: phone,
                    },
                },
            };

            try {
                await this.$store.dispatch(
                    "contactUsEnquiry/changeContactEnquiryStatus",
                    payload,
                );
                this.contactDetails.status = this.newStatus;
                this.showModalView = false;
            } catch (error) {
                console.error("Failed to update enquiry status:", error);
            }
        },
    },
    async mounted() {
        await this.onSearchInput();
    },
};
</script>

<style scoped>
.table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.contact-enquiry-table {
    border-radius: 12px;
}

.pagination-wrapper {
    float: right;
    margin-top: 1rem;
}

.modal-button-row {
    gap: 0.5rem;
}

.search-input-wrapper {
    position: relative;
    width: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
}

/* Match Today & Name dropdown height */
::v-deep .v-select .vs__dropdown-toggle {
    min-height: 38px;
    height: 38px;
}

.search-input {
    width: 100%;
    height: 38px;
    min-height: 38px;
    padding: 0 2rem 0 1rem;
    box-sizing: border-box;
    border: 1px solid var(--slate-200, #dee2e6);
    border-radius: 8px;
    font-size: 0.875rem;
    line-height: 38px;
    color: var(--slate-700, #334155);
    background-color: #fff;
    transition: all 0.15s ease-in-out;
}

.search-input:focus {
    outline: 0;
    border-color: var(--blue, #3b82f6);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-input::placeholder {
    color: #adb5bd;
}

.search-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    color: #6c757d;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Mobile behavior */
@media (max-width: 767.98px) {
    .search-input-wrapper {
        max-width: 100%;
        width: 100% !important;
    }
    
    .search-input-wrapper .search-input {
        width: 100%;
    }

    .table-wrapper {
        margin: 0 -15px;
    }

    .pagination-wrapper {
        float: none;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .modal-button-row {
        flex-direction: column;
    }

    .modal-button-row .col {
        width: 100%;
    }
}

.contact-enquiry-table table {
    width: 100%;
    table-layout: auto;
}

.contact-enquiry-table thead th,
.contact-enquiry-table tbody td {
    padding: 0.75rem 10px !important;
    text-align: left !important;
    vertical-align: middle !important;
}

.contact-enquiry-table thead th > div {
    padding-left: 0 !important;
    margin-left: 0 !important;
}

.contact-enquiry-table tbody td {
    word-break: break-word;
}

.contact-enquiry-table .message-cell {
    max-width: 300px;
}

</style>
